import http from './http-common'

export async function getRmbrate () {
  return await http.get('/staff/goldprices/rmbrate')
}

export async function updateRmbrate (data) {
  return await http.post('/staff/goldprices/rmbrate', data)
}
